import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Field, ErrorMessage } from "formik";

const CMSFormTextArea = forwardRef((props, ref) => {
  const { label, name, theme, required, form, maxLength, ...rest } = props;
  const wrapperRef = useRef(null);

  // Expose scrollIntoView & focus
  useImperativeHandle(ref, () => ({
    scrollIntoView: () => {
      wrapperRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    focus: () => {
      wrapperRef.current?.querySelector("textarea")?.focus();
    },
  }));

  return (
    <div ref={wrapperRef} className="form-group relative">
      {label && (
        <label
          htmlFor={name}
          className={`text-[19px] lg:text-21pt  text-green ${
            required ? "required" : "notRequired"
          } ${form.touched[name] && form.errors[name] ? "isInvalidText" : ""}`}
        >
          {label}{required  && <span className="text-20pt text-orange">*</span>}
        </label>
      )}
      <Field
        as="textarea"
        id={name}
        name={name}
        maxLength={maxLength}
        className={`form-control pb-8 font-mono text-18pt customInput textArea w-full h-[150px] p-2 border border-green overflow-hidden rounded-[15px] focus:outline-none focus:ring-2 focus:ring-green focus:ring-opacity-50 ${
          form.touched[name] && form.errors[name] ? "is-invalid" : ""
        }`}
        {...rest}
      />
      <div
        className={`maxLength absolute right-3 font-mono text-14pt top-3 ${theme === "light" ? "cream" : ""} ${
          form.touched[name] && form.errors[name] ? "light" : ""
        } end`}
      >
        {maxLength ? `${form.values[name].length}/${maxLength}` : null}
      </div>
      {form.touched[name] && form.errors[name] && (
        <span id={`${name}-error`} className="errorMessage">
          <ErrorMessage name={name} />
        </span>
      )}
    </div>
  );
});

export default CMSFormTextArea;
